<template>
  <div class="supplier-detail">
    <el-page-header @back="goBack" content="供应商管理 > 详情">
    </el-page-header>
    <el-table :data="tableData" border size="mini" style="width: 100%;" cell-class-name="table-cell"
            row-class-name="table-row" header-cell-class-name="table-header-cell">
      <el-table-column label="序号" width="50px">
        <template slot-scope="scope">
          {{scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="rawMaterialId" label="材料Id	" width="100px">
      </el-table-column>
      <el-table-column prop="smallImageURL" label="图片	" width="100px">
        <template slot-scope="scope">
          <el-image style="height: 40px;width: 40px;" :src="scope.row.smallImageURL" fit="fill">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="名称	" width="100px">
      </el-table-column>
      <el-table-column label="进货数量/进货金额" align="right" sortable :sort-method="sortInboundAmount" width="90px">
        <template slot-scope="scope">
          {{scope.row.inboundQuantity}}<br>
          {{parseInt(scope.row.inboundAmount)}}
        </template>
      </el-table-column>
      <el-table-column label="待退货数量/待退货金额" align="right" width="90px">
        <template slot-scope="scope">
          {{scope.row.toBeReturnQuantity}}<br>
          {{parseInt(scope.row.toBeReturnAmount)}}
        </template>
      </el-table-column>
      <el-table-column label="退货中数量/退货中金额" align="right" width="90px">
        <template slot-scope="scope">
          {{scope.row.returningQuantity}}<br>
          {{parseInt(scope.row.returningAmount)}}
        </template>
      </el-table-column>
      <el-table-column label="退货失败数量/退货失败金额" align="right" width="90px">
        <template slot-scope="scope">
          {{scope.row.returnFailQuantity}}<br>
          {{parseInt(scope.row.returnFailAmount)}}
        </template>
      </el-table-column>
      <el-table-column prop="toBeReturnRate" label="待退货率" align="right" width="90px">
      </el-table-column>
      <el-table-column prop="returningRate" label="退货中比率" align="right" width="90px">
      </el-table-column>
      <el-table-column prop="returnFailRate" label="退货失败率" align="right" width="90px">
      </el-table-column>
      <el-table-column prop="returnSuccessRate" label="退货成功率" align="right" width="90px">
      </el-table-column>
      <el-table-column prop="returnRate" label="退货率" align="right" width="90px">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import {
    supplierModules
  } from '@r'
  export default {
    data() {
      return {
        tableData:[]
      }
    },
    activated() {
      this.getSupplierDetailList()
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      getSupplierDetailList(){
        supplierModules.statisticsDetail({
          supplierId: this.$route.query.supplierId,
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '获取供应商失败'
            });
            return
          }

          this.tableData = res.ldata;
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        })
      },
      sortInboundAmount(rowA, rowB){
        return parseInt(rowA.inboundAmount)-parseInt(rowB.inboundAmount);
      }
    }
  }
</script>

<style lang="scss">
</style>
